/** In-memory blob previews keyed by mediaId — survives step changes in the same tab. */

type CachedPreview = {
  blobUrl: string;
  type: string;
};

const cache = new Map<string, CachedPreview>();

export function rememberContentPreview(mediaId: string, file: File): string {
  const id = String(mediaId || '').trim();
  if (!id) return URL.createObjectURL(file);

  const prev = cache.get(id);
  if (prev) URL.revokeObjectURL(prev.blobUrl);

  const blobUrl = URL.createObjectURL(file);
  cache.set(id, { blobUrl, type: file.type || '' });
  return blobUrl;
}

export function getCachedContentPreview(
  mediaId?: string | null,
): CachedPreview | null {
  const id = String(mediaId || '').trim();
  if (!id) return null;
  return cache.get(id) || null;
}

export function forgetContentPreview(mediaId?: string | null) {
  const id = String(mediaId || '').trim();
  if (!id) return;
  const prev = cache.get(id);
  if (prev) URL.revokeObjectURL(prev.blobUrl);
  cache.delete(id);
}

export function forgetAllContentPreviews() {
  for (const entry of cache.values()) {
    URL.revokeObjectURL(entry.blobUrl);
  }
  cache.clear();
}
